/**
 * 顶部组件 - 背景图容器
 * 包含：背景图、返回按钮、标题区域
 */

import M_ENV from '~env@1.0'
import M_BRIDGE from '~bridge@1.0'
import M_PROTOCOL from '~protocol@1.0'

const G_IS_APP = M_ENV.isNativeInApp || M_ENV.isWebInApp

export default {
    name: 'TopComponent',

    props: {
        // 移动端背景图
        bgImage: {
            type: String,
            default: ''
        },
        // 移动端Logo图片
        logoImage: {
            type: String,
            default: ''
        },
        // 移动端Logo宽度
        logoWidth: {
            type: Number,
            default: 0
        },
        // 移动端Logo高度
        logoHeight: {
            type: Number,
            default: 0
        },
        // PC端背景图
        pcBgImage: {
            type: String,
            default: ''
        },
        // PC端Logo图片
        pcLogoImage: {
            type: String,
            default: ''
        },
        // PC端标题图
        pcTitleImage: {
            type: String,
            default: ''
        },
        // PC端标题图宽度
        pcTitleWidth: {
            type: Number,
            default: 0
        },
        // PC端标题图高度
        pcTitleHeight: {
            type: Number,
            default: 0
        },
        // 是否为PC端
        isPc: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            isApp: G_IS_APP,
            statusBarHeight: (M_ENV.isNativeInApp || M_ENV.isWebInApp) ? M_ENV.statusBarHeight : 0,
            returnBtnConfig: {
                src: M_PROTOCOL.addUrlProtocol('//coss-action.fenqile.com/pageconfig201/M00/ex/20250114204118-ab32af3f-b558-4828-9341-37ac33c4528d.png.webp')
            }
        }
    },

    mounted () {
        // 在App环境隐藏原生头部（仅移动端）
        if (this.isApp && !this.isPc) {
            M_BRIDGE.invokeJsBridge('hideTitle')
            M_BRIDGE.invokeJsBridge('adjustiPhoneXBottomColor', { hide_bottom: 1 })
        }
    },

    computed: {
        /**
         * 移动端Logo图片样式
         * 如果有宽高，使用动态尺寸；否则使用默认样式
         */
        getLogoImageStyle () {
            if (this.logoWidth && this.logoHeight) {
                return {
                    width: `${this.logoWidth / 375 * 100}vw`,
                    height: `${this.logoHeight / 375 * 100}vw`
                }
            }
            return {}
        },

        /**
         * PC端标题图样式
         * 如果有宽高，使用动态尺寸；否则使用默认样式
         */
        getTitleImageStyle () {
            if (this.pcTitleWidth && this.pcTitleHeight) {
                return {
                    width: `${this.pcTitleWidth / 1920 * 100}vw`,
                    height: `${this.pcTitleHeight / 1920 * 100}vw`
                }
            }
            return {}
        }
    },

    methods: {
        /**
         * 处理返回按钮点击
         */
        handleBackClick () {
            this.$emit('back-click')
            // 使用lotus.navigator.back()返回
            M_BRIDGE.lotus.navigator.back()
        },

        /**
         * 处理Logo点击（PC端）
         * 刷新页面
         */
        handleLogoClick () {
            this.$emit('logo-click')
            // 刷新页面
            window.location.reload()
        }
    }
}